export default {"src":"/_next/static/media/section5-icon3.cee2084e.svg","height":58,"width":57,"blurWidth":0,"blurHeight":0};